const theme = {
    black : '#000000',
    gray : '#DCDCDC',
    blue : '#1153e2',
    bgColor : '#FAFAFA',
    projectTitleGray: '#575757',
    projectDateGray: '#949494',

    // 10도 이하
    cold : '#e0effc',
    // 11 ~ 20도
    cool : '#e6ffec',
    // 21 ~ 25도
    warm : '#fff5e9',
    // 25도 이상
    hot : '#ff5555'
}

export default theme;